<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='学员奖金汇总统计' :label2='this.title' url="/report/payment/stu/section"></PageHead>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <ExportButton :url='exportUrl' buttonname="导出"></ExportButton>
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <div v-html="tableData">
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentStuUser',
  data () {
    return {
      condition: {
        token: '',
        name: '',
        id: ''
      },
      tableData: null,
      exportUrl: this.$utils.Url.zpgl + '/api/APIMoneyGrant/StuUserPaymentListOut'
    }
  },
  methods: {
    Search: function () {
      this.$http.post(this.$utils.Url.zpgl + '/api/APIMoneyGrant/StuUserPaymentList', this.condition)
        .then(res => {
          if (res.data.Code === 0) {
            this.tableData = res.data.Data
          } else {
            this.$message({
              message: res.data.Msg + '，' + res.data.Error,
              type: 'error'
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$message({
            message: '查询失败',
            type: 'error'
          })
        })
    }
  },
  mounted: function () {
    this.condition.token = sessionStorage.getItem('token')
    this.condition.id = this.$route.params.id
    this.condition.name = this.$route.params.name
    this.title = this.condition.name + ' 月度奖金详细'
    this.Search()
  }
}
</script>

<style scoped="scoped">
  @import '../../../../assets/css/achievementinfo.css'
</style>
